// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__n636y","logo":"Navbar_logo__dMLia"};